import React from "react";
import PageShell from "../components/PageShell";
import SimuladorTravagem from "../components/SimuladorTravagem";
import GuiaConforto from "../components/GuiaConforto";

export default function SimuladorPage() {
  return (
    <PageShell testId="page-simulador">
      <SimuladorTravagem />
      <GuiaConforto />
    </PageShell>
  );
}
